const host = (import.meta.env.VITE_HOST || 'https://erd.dbdesigner.net').replace(/\/+$/, '')

export const env = {
    socketIoServer: import.meta.env.VITE_SOCKET_IO_SERVER || 'api.dbdesigner.net',
    apiUrl: (import.meta.env.VITE_API_URL || 'https://api.dbdesigner.net/api/v2').replace(/\/+$/, '') + '/',
    appUrl: import.meta.env.VITE_APP_URL || 'https://www.dbdesigner.net',
    designerUrl: (import.meta.env.VITE_DESIGNER_URL || `${host}/designer/schema`).replace(/\/+$/, ''),
    host,
    appName: 'DB Designer',
    appEmail: 'info@dbdesigner.net',
    salt: 'salt.duh!',
    defaultLocale: 'en',
    localeOptions: [
        {id: 'en', name: 'English', direction: 'ltr'},
        {id: 'es', name: 'Español', direction: 'ltr'},
        {id: 'bn', name: 'Bengali', direction: 'ltr'},
        {id: 'ca', name: 'Catalan', direction: 'ltr'},
        {id: 'cs', name: 'Czech', direction: 'ltr'},
        {id: 'da', name: 'Danish', direction: 'ltr'},
        {id: 'de', name: 'German', direction: 'ltr'},
        {id: 'eo', name: 'Esperanto', direction: 'ltr'},
        {id: 'fa', name: 'Persian', direction: 'ltr'},
        {id: 'fi', name: 'Finnish', direction: 'ltr'},
        {id: 'fr', name: 'French', direction: 'ltr'},
        {id: 'gr', name: 'Greek', direction: 'ltr'},
        {id: 'gr', name: 'Indonesian', direction: 'ltr'},
        {id: 'it', name: 'Italian', direction: 'ltr'},
        {id: 'ja', name: 'Japanese', direction: 'ltr'},
        {id: 'kn', name: 'Kannada', direction: 'ltr'},
        {id: 'nb_no', name: 'Norwegian Bokmål', direction: 'ltr'},
        {id: 'nl', name: 'Dutch', direction: 'ltr'},
        {id: 'pl', name: 'Polish', direction: 'ltr'},
        {id: 'pt_br', name: 'Portuguese', direction: 'ltr'},
        {id: 'ro', name: 'Romanian', direction: 'ltr'},
        {id: 'ru', name: 'Russian', direction: 'ltr'},
        {id: 'tr', name: 'Turkish', direction: 'ltr'},
        {id: 'ua', name: 'Ukrainian', direction: 'ltr'},
        {id: 'uz', name: 'Uzbek', direction: 'ltr'},
        {id: 'vi', name: 'Vietnamese', direction: 'ltr'},
        {id: 'zh', name: 'Chinese', direction: 'ltr'},
    ],
    dbImportFromLinkSupported: false,
    g_id: '405529418010-3ttdh59oir17hf7df6hnm0drgtrgvth0.apps.googleusercontent.com',
    appVersion: '2.0'
};
